import { BaseContainerModel } from '../../base-container.model';
import { bl_inv_current_location_stock_balance_RowClass} from '../../../dbschema';

export class InvCurrentLocationStockBalanceContainerModel extends BaseContainerModel {
  bl_inv_current_location_stock_balance: bl_inv_current_location_stock_balance_RowClass = new bl_inv_current_location_stock_balance_RowClass();
}
